document.addEventListener('click', function (e) {
  const button = e.target.closest('#load-more');
  if (!button) return;

  const grid = document.querySelector('#product-grid');
  if (!grid) return;

  let nextUrl = button.dataset.nextUrl;
  if (!nextUrl) return;

  button.textContent = 'Loading...';

  // ✅ Get section ID dynamically (CRITICAL)
  const sectionId = grid.dataset.id;

  // Force section render
  if (!nextUrl.includes('section_id')) {
    nextUrl += (nextUrl.includes('?') ? '&' : '?') + 'section_id=' + sectionId;
  }

  fetch(nextUrl)
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // ✅ Append ONLY product items
      const newItems = doc.querySelectorAll('#product-grid > li');
      newItems.forEach(item => grid.appendChild(item));

      // ✅ Get new Load More button from fetched section
      const newButton = doc.querySelector('#load-more');

      if (newButton && newButton.dataset.nextUrl) {
        button.dataset.nextUrl = newButton.dataset.nextUrl;
        button.textContent = 'Load more';
      } else {
        button.remove();
      }
    })
    .catch(() => {
      button.textContent = 'Load more';
    });
});